import { render } from "./KryptonPopinBackground.vue?vue&type=template&id=d42e8c06&lang=pug"
import script from "./KryptonPopinBackground.vue?vue&type=script&lang=js"
export * from "./KryptonPopinBackground.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__